import React from "react";
import { ThemeProvider } from "./theme";
import { PrivacyProvider } from "./privacy";

export default function ContextProvider({ children }) {
  return (
    <ThemeProvider>
      <PrivacyProvider>{children}</PrivacyProvider>
    </ThemeProvider>
  );
}
